import React, { Component } from 'react';
import * as GlobalActions from '../../../reducers/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { logEvent, EVENT_CATEGORIES, EVENT_ACTIONS } from '../../../services/Analytics';
import { Event } from '../Tracking/Track';
import * as IMAGES from '../../../Images';
import { guc as localGuc} from '../../../services/Localisation';
import {
  card,
  PlayVideo,
  PlayVideoMobile,
  Video,
  VideoContent,
  VideoContentMobile,
  VideoHeader,
  VideoHeaderMobile,
  VideoMobile,
  VideoThumbnail,
  VideoThumbnailMobile
} from '../../../partnerStyles';
import view from '../../../Enums';
import Fade from 'react-reveal/Fade';

class WhatPartnersSay extends Component {


  render() {
    let gc = this.props.gc;
    let guc = this.props.guc;
    let gs = this.props.gs;
    let gi = this.props.gi;

    let videoComponent;
    let videoThumbnail;
    let videoThumbnailHeight;
    let videoThumbnailWidth;
    let videoHeader;
    let videoContent;
    let playVideo;

    if (this.props.viewMode == view.DESKTOP) {
      videoComponent = { ...card, ...Video };
      videoThumbnail = VideoThumbnail;
      videoThumbnailHeight = '172px';
      videoThumbnailWidth = '380x';
      videoHeader = VideoHeader;
      videoContent = VideoContent;
      playVideo = PlayVideo;
    }
    if (this.props.viewMode == view.MOBILE) {
      videoComponent = { ...card, ...VideoMobile };
      videoThumbnail = VideoThumbnailMobile;
      videoThumbnailHeight = '152px';
      videoThumbnailWidth = '266x';
      videoHeader = VideoHeaderMobile;
      videoContent = VideoContentMobile;
      playVideo = PlayVideoMobile;
    }

    return (
      <div style={gs('video_banner')} ref={this.props.setHearFromPartnersRef}>
        <div style={gs('bold_big_head')}>{gc('hear_from_our_partner')}</div>
        <div style={gs('bold_big_sub_head')}>
          {gc('hear_from_our_partner_content')}
        </div>

        <Fade bottom>
          <div style={{ ...gs('video_banner_videos') }}>
            <div
              style={{
                minWidth: '15px'
              }}
            ></div>
            {guc('testimonial_1') && <div style={{ ...videoComponent }}>
              <div style={videoThumbnail}>
                <img
                  src={gi('THUMB_ONE')}
                  alt="thumbnail"
                  className="hover"
                  height={videoThumbnailHeight}
                  width={videoThumbnailWidth}
                  onClick={() => {
                    Event('Partner Page', 'Testimonial video 1 played', '', '');
                    this.props.handleOpenVideoModal(
                      guc('testimonial_1'),
                      guc('name_thumb_1')
                    );
                  }}
                />
              </div>
              <div
                style={playVideo}
                onClick={() => {
                  logEvent(EVENT_CATEGORIES.PARTNER_PAGE, EVENT_ACTIONS.TESTIMONIAL_VIDEO_1_PLAYED);
                  this.props.handleOpenVideoModal(
                      guc('testimonial_1'),
                      guc('name_thumb_1')
                  );
                }}
              >
                <img src={IMAGES.TRIANGLE} alt="play" /> {localGuc('play_video','PLAY VIDEO')}
              </div>
              <div style={videoHeader}>{gc('name_thumb_1')}</div>
              <div style={videoContent}>{gc('thumb_sub_1')}</div>
            </div>}
  
            {guc('testimonial_2') && <div style={videoComponent}>
              <div style={videoThumbnail}>
                <img
                  src={gi('THUMB_TWO')}
                  alt="thumbnail"
                  className="hover"
                  height={videoThumbnailHeight}
                  width={videoThumbnailWidth}
                  onClick={() => {
                    Event('Partner Page', 'Testimonial video 2 played', '', '');
                    this.props.handleOpenVideoModal(
                      guc('testimonial_2'),
                      guc('name_thumb_2')
                    );
                  }}
                />
              </div>
              <div
                style={playVideo}
                onClick={() => {
                  logEvent(EVENT_CATEGORIES.PARTNER_PAGE, EVENT_ACTIONS.TESTIMONIAL_VIDEO_2_PLAYED);
                  this.props.handleOpenVideoModal(
                      guc('testimonial_2'),
                      guc('name_thumb_2')
                  );
                }}
              >
                <img src={IMAGES.TRIANGLE} alt="play" /> {localGuc('play_video','PLAY VIDEO')}
              </div>
              <div style={videoHeader}>{gc('name_thumb_2')}</div>
              <div style={videoContent}>{gc('thumb_sub_2')}</div>
            </div>}
  
            {guc('testimonial_3') && <div style={{ ...videoComponent, marginRight: '0' }}>
              <div style={videoThumbnail}>
                <img
                  src={gi('THUMB_THREE')}
                  alt="thumbnail"
                  className="hover"
                  height={videoThumbnailHeight}
                  width={videoThumbnailWidth}
                  onClick={() => {
                    Event('Partner Page', 'Testimonial video 3 played', '', '');
                    this.props.handleOpenVideoModal(
                      guc('testimonial_3'),
                      guc('name_thumb_3')
                    );
                  }}
                />
              </div>
              <div
                style={playVideo}
                onClick={() => {
                  logEvent(EVENT_CATEGORIES.PARTNER_PAGE, EVENT_ACTIONS.TESTIMONIAL_VIDEO_3_PLAYED);
                  this.props.handleOpenVideoModal(
                      guc('testimonial_3'),
                      guc('name_thumb_3')
                  );
                }}
              >
                <img src={IMAGES.TRIANGLE} alt="play" /> {localGuc('play_video','PLAY VIDEO')}
              </div>
              <div style={videoHeader}>{gc('name_thumb_3')}</div>
              <div style={videoContent}>{gc('thumb_sub_3')}</div>
            </div>}
            <div
              style={{
                minWidth: '15px'
              }}
            ></div>
          </div>
        </Fade>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WhatPartnersSay);
